import type { MouseEventHandler, ReactNode } from "react";

import { SWReactIcons } from "@similarweb/icons";
import { Text } from "@similarweb/ui-components/foundations";

import { StyledShowMoreButton } from "./styles";

interface IProps {
    isCollapsed: boolean;
    children: ReactNode;
    onClick?: MouseEventHandler<HTMLButtonElement>;
}

const CollapsibleUnderlineButton = ({ isCollapsed, children, onClick }: IProps) => {
    return (
        <StyledShowMoreButton
            isCollapsed={isCollapsed}
            onClick={onClick}
        >
            <Text
                fontVariant="caption"
                textDecoration="underline"
            >
                {children}
            </Text>

            <SWReactIcons
                iconName="arrow"
                size="10px"
            />
        </StyledShowMoreButton>
    );
};

export default CollapsibleUnderlineButton;
